<template>
  <v-dialog
    v-model="show"
    persistent
    width="300" >
    <v-card color="primary" dark class="pt-4 pl-2 pr-2">
      <v-card-text>
        {{ text }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import events from 'Store/events'
export default {
  name: 'loader',
  data () {
    return {
      show: false,
      text: ''
    }
  },
  mounted () {
    events.subLoaderShow((text) => {
      this.text = text || this.$t('loading.statusDefault')
      this.show = true
    })

    events.subLoaderHide(() => {
      this.show = false
    })
  }
}
</script>

<style scoped>
</style>
